"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLocaleKey = void 0;
exports.defaultLocaleKey = {
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS',
    SHOWING: 'SHOWING',
    TO: 'TO',
    FROM: 'FROM',
    OF: 'OF',
    OR: 'OR',
    AND: 'AND',
    EQUAL: 'EQUAL',
    RESULTS: 'RESULTS',
    CLOSE: 'CLOSE',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    APPLY: 'APPLY',
    ADD_FILTER: 'ADD_FILTER',
    CLEAR_FILTER: 'CLEAR_FILTER',
    ADD_CONDITION: 'ADD_CONDITION',
    TRUE: 'TRUE',
    FALSE: 'FALSE',
    SELECT_OPTIONS: 'SELECT_OPTIONS',
    REMOVE_CONDITION: 'REMOVE_CONDITION',
    SEARCH: 'SEARCH',
    FAVORITES: 'FAVORITES',
    NEW: 'NEW',
    TODAY: 'TODAY',
    CLEAR: 'CLEAR',
    SOMETHING_WRONG: 'SOMETHING_WRONG',
    DATA_BY_FILTER_EMPTY: 'DATA_BY_FILTER_EMPTY',
    DATA_EMPTY: 'DATA_EMPTY',
    N_A: 'N_A',
    ALL_DAY: 'ALL_DAY',
    OPEN: 'OPEN',
    CONTINUE: 'CONTINUE',
    FILE_INPUT: 'Click to upload or drag and drop file',
    REMOVE: 'REMOVE',
    LOGO_TEXT: 'LOGO_TEXT',
    TABLE_FILTER_DESCRIPTION: 'TABLE_FILTER_DESCRIPTION',
    STEP: 'STEP',
    SUGGESTED: 'SUGGESTED',
    INVALID_DATE: 'INVALID_DATE',
    STEPS_TO_COMPLETE: 'STEPS_TO_COMPLETE',
    LAST_STEP: 'LAST_STEP',
};
//# sourceMappingURL=defaultLocaleKey.js.map